// @ts-check

import BaseModel from "@kaspernj/api-maker/build/base-model.js"
import ActiveStorageAttachment from "./active-storage-attachment.js"
import PhotoSheetProductOrderLine from "./photo-sheet-product-order-line.js"

const modelClassData = {
  "attributes": {
    "created_at": {
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      },
      "name": "created_at",
      "selected_by_default": null,
      "translated": null
    },
    "id": {
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      },
      "name": "id",
      "selected_by_default": null,
      "translated": null
    },
    "updated_at": {
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      },
      "name": "updated_at",
      "selected_by_default": null,
      "translated": null
    },
    "photo_sheet_image_path": {
      "column": null,
      "name": "photo_sheet_image_path",
      "selected_by_default": false,
      "translated": null
    }
  },
  "className": "PhotoSheetProductOrderLineGeneration",
  "collectionKey": "photo_sheet_product_order_line_generations",
  "collectionName": "photo_sheet_product_order_line_generations",
  "i18nKey": "photo_sheet_product_order_line_generation",
  "camelizedLower": "photoSheetProductOrderLineGeneration",
  "name": "PhotoSheetProductOrderLineGeneration",
  "nameDasherized": "photo-sheet-product-order-line-generation",
  "pluralName": "photo_sheet_product_order_line_generations",
  "ransackable_associations": [
    {
      "className": "Log",
      "collectionName": "logs",
      "foreignKey": "trackable_id",
      "name": "logs",
      "macro": "has_many",
      "resource_name": "Log",
      "through": null
    },
    {
      "className": "ActiveStorage::Attachment",
      "collectionName": "active_storage_attachments",
      "foreignKey": "record_id",
      "name": "photo_sheet_image_attachment",
      "macro": "has_one",
      "resource_name": "ActiveStorageAttachment",
      "through": null
    },
    {
      "className": "ActiveStorage::Blob",
      "collectionName": "active_storage_blobs",
      "foreignKey": "blob_id",
      "name": "photo_sheet_image_blob",
      "macro": "has_one",
      "resource_name": "ActiveStorageBlob",
      "through": "photo_sheet_image_attachment"
    },
    {
      "className": "PhotoSheetProductOrderLine",
      "collectionName": "photo_sheet_product_order_lines",
      "foreignKey": "photo_sheet_product_order_line_id",
      "name": "photo_sheet_product_order_line",
      "macro": "belongs_to",
      "resource_name": "PhotoSheetProductOrderLine",
      "through": null
    },
    {
      "className": "SheetSize",
      "collectionName": "sheet_sizes",
      "foreignKey": "sheet_size_id",
      "name": "sheet_size",
      "macro": "has_one",
      "resource_name": "SheetSize",
      "through": "photo_sheet_product_order_line"
    },
    {
      "className": "Tagging",
      "collectionName": "taggings",
      "foreignKey": "resource_id",
      "name": "taggings",
      "macro": "has_many",
      "resource_name": "Tagging",
      "through": null
    },
    {
      "className": "Tag",
      "collectionName": "tags",
      "foreignKey": "tag_id",
      "name": "tags",
      "macro": "has_many",
      "resource_name": "Tag",
      "through": "taggings"
    },
    {
      "className": "Tenant",
      "collectionName": "tenants",
      "foreignKey": "tenant_id",
      "name": "tenant",
      "macro": "belongs_to",
      "resource_name": "Tenant",
      "through": null
    },
    {
      "className": "WorkerPlugins::WorkplaceLink",
      "collectionName": "workplace_links",
      "foreignKey": "resource_id",
      "name": "workplace_links",
      "macro": "has_many",
      "resource_name": "WorkplaceLink",
      "through": null
    }
  ],
  "ransackable_attributes": [
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "id_string",
      "column": null
    },
    {
      "name": "photo_sheet_product_order_line_id",
      "column": {
        "default": null,
        "name": "photo_sheet_product_order_line_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "tenant_id",
      "column": {
        "default": null,
        "name": "tenant_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "updated_at",
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      }
    }
  ],
  "ransackable_scopes": [
    {
      "name": "in_current_workplace"
    },
    {
      "name": "soft_deleted_filter"
    },
    {
      "name": "sort_by_in_current_workplace_asc"
    },
    {
      "name": "sort_by_in_current_workplace_desc"
    }
  ],
  "relationships": [
    {
      "className": "ActiveStorage::Attachment",
      "collectionName": "active_storage_attachments",
      "foreignKey": "record_id",
      "name": "photo_sheet_image_attachment",
      "macro": "has_one",
      "resource_name": "ActiveStorageAttachment",
      "through": null
    },
    {
      "className": "PhotoSheetProductOrderLine",
      "collectionName": "photo_sheet_product_order_lines",
      "foreignKey": "photo_sheet_product_order_line_id",
      "name": "photo_sheet_product_order_line",
      "macro": "belongs_to",
      "resource_name": "PhotoSheetProductOrderLine",
      "through": null
    }
  ],
  "paramKey": "photo_sheet_product_order_line_generation",
  "primaryKey": "id"
}

/** Frontend model for PhotoSheetProductOrderLineGeneration. */
export default class PhotoSheetProductOrderLineGeneration extends BaseModel {
  /** @returns {typeof modelClassData} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {Date} */
  createdAt() {
    return this.readAttributeUnderscore("created_at")
  }

  /** @returns {boolean} */
  hasCreatedAt() {
    const value = this.createdAt()

    return this._isPresent(value)
  }

  /** @returns {string} */
  id() {
    return this.readAttributeUnderscore("id")
  }

  /** @returns {boolean} */
  hasId() {
    const value = this.id()

    return this._isPresent(value)
  }

  /** @returns {Date} */
  updatedAt() {
    return this.readAttributeUnderscore("updated_at")
  }

  /** @returns {boolean} */
  hasUpdatedAt() {
    const value = this.updatedAt()

    return this._isPresent(value)
  }

  /** @returns {any} */
  photoSheetImagePath() {
    return this.readAttributeUnderscore("photo_sheet_image_path")
  }

  /** @returns {boolean} */
  hasPhotoSheetImagePath() {
    const value = this.photoSheetImagePath()

    return this._isPresent(value)
  }

  /** @returns {import("./active-storage-attachment.js").default | null} */
  photoSheetImageAttachment() {
    return this._readHasOneReflection({modelClass: ActiveStorageAttachment, reflectionName: "photo_sheet_image_attachment"})
  }

  /** @returns {Promise<import("./active-storage-attachment.js").default | null>} */
  loadPhotoSheetImageAttachment() {
    if (!("id" in this)) throw new Error("Primary key method wasn't defined: id")

    const id = this.id()
    const ransack = {}

    ransack["record_id_eq"] = id

    return this._loadHasOneReflection(
      {
        reflectionName: "photo_sheet_image_attachment",
        model: this,
        modelClass: ActiveStorageAttachment
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./active-storage-attachment.js").default | null>} */
  ensurePhotoSheetImageAttachmentLoaded() {
    return this.ensureAssociationLoaded("photo_sheet_image_attachment")
  }

  /** @returns {import("./photo-sheet-product-order-line.js").default | null} */
  photoSheetProductOrderLine() {
    return this._readBelongsToReflection({modelClass: PhotoSheetProductOrderLine, reflectionName: "photo_sheet_product_order_line"})
  }

  /** @returns {Promise<import("./photo-sheet-product-order-line.js").default | null>} */
  loadPhotoSheetProductOrderLine() {
    if (!("photoSheetProductOrderLineId" in this)) throw new Error("Foreign key method wasn't defined: photoSheetProductOrderLineId")

    const id = this.photoSheetProductOrderLineId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "photo_sheet_product_order_line",
        model: this,
        modelClass: PhotoSheetProductOrderLine
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./photo-sheet-product-order-line.js").default | null>} */
  ensurePhotoSheetProductOrderLineLoaded() {
    return this.ensureAssociationLoaded("photo_sheet_product_order_line")
  }
}
